export const CompanyType = {
  Factory: 'Factory',
  Program: 'Program',
};

export const SurveyType = {
  Checklist: 'checklist',
  CustomPanel: 'customPanel',
  Datasheet: 'datasheet',
};

export const ServiceTypes = {
  CAP: 'cap',
  SAQ: 'saq',
  HIDDEN: 'hidden'
};
